// extracted by mini-css-extract-plugin
export default {"thankYouFooter":"ThankYouFooter_thankYouFooter__6vAli"};